let json_map = globals.data;

const palette = [
  { fill: "#93c5fd", stroke: "#1d4ed8", activeMap: "#0ea5e9", activeCard: "#f59e0b" },
  { fill: "#86efac", stroke: "#15803d", activeMap: "#10b981", activeCard: "#f97316" },
  { fill: "#f9a8d4", stroke: "#be185d", activeMap: "#ec4899", activeCard: "#f97316" },
  { fill: "#c4b5fd", stroke: "#6d28d9", activeMap: "#8b5cf6", activeCard: "#f59e0b" },
  { fill: "#fcd34d", stroke: "#b45309", activeMap: "#f59e0b", activeCard: "#ea580c" },
  { fill: "#7dd3fc", stroke: "#0369a1", activeMap: "#0284c7", activeCard: "#ea580c" }
];

let selectedAreaId = null;
const areaState = new Map();
let map = null;
let shippingList = null;

function waitForLeaflet(attempt = 0) {
  if (typeof window.L !== "undefined") {
    initMap();
    return;
  }

  if (attempt >= 50) {
    console.error("Leaflet no se pudo cargar.");
    return;
  }

  setTimeout(() => waitForLeaflet(attempt + 1), 100);
}

function formatShippingPrice(value) {
  return new Intl.NumberFormat("es-PA", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  }).format(value);
}

function getFeatureName(feature) {
  return feature.properties?.name || feature.properties?.name || "Sin nombre";
}

function buildCard(meta) {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "shipping-area-card";
  button.dataset.areaId = meta.id;
  button.setAttribute("aria-label", `Seleccionar area de envio: ${meta.name}`);
  button.innerHTML = `
    <div class="shipping-area-title">
      <span class="shipping-dot" style="background-color: ${meta.colors.fill}"></span>
      <span>${meta.name}</span>
    </div>
    <p>Envio: ${meta.shippingText}</p>
    <p>Mínimo de compra: ${meta.minimo}</p>
    <p class="shipping-note">Haz clic para resaltar en el mapa.</p>
  `;

  button.addEventListener("click", () => setActiveArea(meta.id, "card"));
  return button;
}

function getLayerStyle(meta, source, isHovered) {
  if (source === "map") {
    return {
      color: meta.colors.stroke,
      weight: 2.8,
      fillColor: meta.colors.activeMap,
      fillOpacity: 0.62
    };
  }

  if (source === "card") {
    return {
      color: meta.colors.stroke,
      weight: 3,
      fillColor: meta.colors.activeCard,
      fillOpacity: 0.66
    };
  }

  if (isHovered) {
    return {
      color: meta.colors.stroke,
      weight: 2,
      fillColor: meta.colors.fill,
      fillOpacity: 0.48
    };
  }

  return {
    color: meta.colors.stroke,
    weight: 1.4,
    fillColor: meta.colors.fill,
    fillOpacity: 0.3
  };
}

function paintAllLayers() {
  areaState.forEach(meta => {
    const isSelected = meta.id === selectedAreaId;
    const style = getLayerStyle(meta, isSelected ? meta.selectedSource : null, false);
    meta.layer.setStyle(style);
    meta.card.classList.toggle("active", isSelected);
  });
}

function setActiveArea(id, source) {
  const meta = areaState.get(id);
  if (!meta) {
    return;
  }

  selectedAreaId = id;
  meta.selectedSource = source;
  paintAllLayers();

  if (source === "card") {
    map.fitBounds(meta.layer.getBounds(), { padding: [20, 20], maxZoom: 10 });
  }

  meta.layer.openPopup();
}

function getPolygonCenter(coordinates) {
  let x = 0, y = 0, count = 0;
  coordinates[0].forEach(coord => {
    x += coord[0];
    y += coord[1];
    count++;
  });
  return [y / count, x / count];
}

function initMap() {
  if (map) {
    return;
  }

  shippingList = document.getElementById("shipping-areas");
  if (!shippingList) {
    return;
  }

  map = L.map("map", {
    center: [8.9936, -79.5197],
    zoom: 7
  });

  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 12,
    attribution: "© OpenStreetMap"
  }).addTo(map);

  // Crear icono personalizado de ubicación
  const locationIcon = L.icon({
    iconUrl: "https://cdn.shopify.com/s/files/1/0286/2773/0484/files/logo-map-hyperclean.jpg?v=1778337757",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
    className: "location-icon"
  });

  fetch(json_map)
    .then(r => r.json())
    .then(data => {
      data.features.forEach((feature, index) => {
        feature.properties.__index = index;
        feature.properties.__areaId = `${getFeatureName(feature)}-${index}`;
      });

      const geoLayer = L.geoJSON(data, {
        style: feature => {
          const index = feature.properties.__index || 0;
          const colors = feature.properties.color ? { fill: feature.properties.color, stroke: feature.properties.color } : palette[index % palette.length];
          return {
            color: colors.stroke,
            weight: 1.4,
            fillColor: feature.properties.color,
            fillOpacity: 0.3
          };
        },
        onEachFeature: (feature, layer) => {
          const name = getFeatureName(feature);
          const id = feature.properties.__areaId;
          const index = feature.properties.__index;
          const colors = feature.properties.color ? { fill: feature.properties.color, stroke: feature.properties.color } : palette[index % palette.length];
          const shippingText = feature.properties.tarifa;
          const minimo = feature.properties.minimo || "N/A";
          const typeDelivery = feature.properties.type_delivery || "daily";

          // Agregar marcador con icono en el centroide
          if (feature.geometry.type === "Polygon") {
            const center = getPolygonCenter(feature.geometry.coordinates);
            L.marker(center, { icon: locationIcon })
              .bindPopup(`
                <strong style="font-size:16px;">${name}</strong><br>
                <span style="font-size:14px;">Costo de envio: ${shippingText}</span><br>
                <span style="font-size:14px;">Mínimo de compra: ${minimo}</span><br>
                <span style="font-size:14px;">Entrega estimada: ${typeDelivery === "daily" ? "Todos los días" : "Coordinar asesor"}</span>
              `)
              .addTo(map);
          }

          layer.bindPopup(`
            <strong style="font-size:18px;">${name}</strong><br>
            <span style="font-size:14px;">Costo de envio: ${shippingText}</span><br>
            <span style="font-size:14px;">Mínimo de compra: ${minimo}</span><br>
            <span style="font-size:14px;">Entrega estimada: ${typeDelivery === "daily" ? "Todos los días" : "Coordinar asesor"}</span>
          `);

          const meta = {
            id,
            name,
            colors,
            shippingText,
            minimo,
            layer,
            card: null,
            selectedSource: null
          };

          const card = buildCard(meta);
          meta.card = card;
          areaState.set(id, meta);
          shippingList.appendChild(card);

          layer.on("click", () => setActiveArea(id, "map"));
          layer.on("mouseover", () => {
            if (selectedAreaId !== id) {
              layer.setStyle(getLayerStyle(meta, null, true));
            }
          });
          layer.on("mouseout", () => {
            if (selectedAreaId !== id) {
              layer.setStyle(getLayerStyle(meta, null, false));
            }
          });
        }
      }).addTo(map);

      map.fitBounds(geoLayer.getBounds(), { padding: [20, 20] });
    })
    .catch(() => {
      const error = document.createElement("p");
      error.className = "shipping-note";
      error.textContent = "No se pudo cargar el mapa de distritos.";
      shippingList.appendChild(error);
    });
}

waitForLeaflet();